(function () {
  function initBestBlackPants(root) {
    if (!root || root.dataset.bbpInitialized === 'true') return;
    root.dataset.bbpInitialized = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealItems = root.querySelectorAll('.bbp-reveal');

    if (!reducedMotion && 'IntersectionObserver' in window) {
      root.classList.add('bbp--motion');
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach(function (item) { revealObserver.observe(item); });
    } else {
      revealItems.forEach(function (item) { item.classList.add('is-visible'); });
    }

    var navLinks = root.querySelectorAll('[data-bbp-jump]');
    var cards = root.querySelectorAll('[data-bbp-card]');
    if ('IntersectionObserver' in window && navLinks.length && cards.length) {
      var navObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          navLinks.forEach(function (link) { link.classList.remove('is-active'); });
          var activeLink = root.querySelector('[data-bbp-jump][href="#' + entry.target.id + '"]');
          if (activeLink) activeLink.classList.add('is-active');
        });
      }, { rootMargin: '-38% 0px -38% 0px', threshold: 0.01 });
      cards.forEach(function (card) { navObserver.observe(card); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bbp-section]').forEach(initBestBlackPants);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBestBlackPants(event.target.querySelector('[data-bbp-section]'));
  });
})();
